import React, { useEffect, useState } from "react";
import { getSingleProductApi } from "../api/";
import { Link, useParams } from "react-router-dom";
import { Loader, PageHero } from "../components";
import styled from "styled-components";
import { addToCart } from "../actions";
import { useDispatch, useSelector } from "react-redux";
import { currency } from "../helper";

const Product = () => {
  const [product, setProduct] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isAdded, setIsAdded] = useState(false);

  const { id } = useParams();
  const dispatch = useDispatch();
  const { cartProducts } = useSelector((state) => state.cart);

  const getSingleProduct = async (id) => {
    let response = {};
    try {
      response = await getSingleProductApi(id);
    } catch (error) {
      console.log(error);
    }
    setProduct(response);
    setIsLoading(false);
  };

  useEffect(() => {
    getSingleProduct(id);

    cartProducts.forEach((product) => {
      if (product._id == id) {
        setIsAdded(true);
      }
    });
  }, []);

  return (
    <>
      {isLoading ? (
        <LoaderWrapper>
          <Loader></Loader>
        </LoaderWrapper>
      ) : (
        <>
          <PageHero title={product.name} product={true}></PageHero>
          <Link
            style={{ display: "block", marginTop: "5vh", marginLeft: "10vw" }}
            to="/products"
          >
            <button className="btn">Back to Products</button>
          </Link>
          <Wrapper>
            <div className="image">
              <img src={product.image} alt="" />
            </div>
            <div className="info">
              <h1 className="name">{product.name.toLowerCase()}</h1>
              <h3 className="price">
                {currency} {product.price}
              </h3>
              <p className="about">{product.description}</p>
              <p className="line"></p>
              <table>
                <tbody>
                  <tr>
                    <th>Available</th>
                    <th>:</th>
                    <td>In stock</td>
                  </tr>
                  <tr>
                    <th>Brand</th>
                    <th>:</th>
                    <td>
                      {product.company[0].toUpperCase() +
                        product.company.substring(1)}
                    </td>
                  </tr>
                  <tr>
                    <th>Colors:</th>
                    <th>:</th>
                    <td className="colors">
                      {product.colors.map((color) => (
                        <span style={{ backgroundColor: color }}></span>
                      ))}
                    </td>
                  </tr>
                </tbody>
              </table>
              {isAdded ? (
                <button className="btn add-to-cart added" disabled>
                  ADDED
                </button>
              ) : (
                <Link to="/cart">
                  <button
                    className="btn add-to-cart"
                    onClick={() => {
                      dispatch(addToCart(product));
                      setIsAdded(true);
                    }}
                  >
                    ADD TO CART
                  </button>
                </Link>
              )}
            </div>
          </Wrapper>
        </>
      )}
    </>
  );
};

const LoaderWrapper = styled.div`
  height: 100vh;
  width: 100vw;
  display: grid;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  background-color: var(--color-white);
  z-index: 100;
`;

const Wrapper = styled.section`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 50px;
  width: 80vw;
  margin: 10vh auto;
  > .image {
    img {
      width: 100%;
      height: 80vh;
      object-fit: cover;
      border-radius: 10px;
      box-shadow: 0 0 10px 0px #999999;
    }
  }
  > .info {
    > .name {
      font-size: 2.5em;
      font-weight: bold;
      text-transform: capitalize;
    }
    > .price {
      font-size: 1.6em;
      color: var(--color-primary-3);
      margin-bottom: 20px;
    }
    > .about {
      text-align: justify;
      line-height: 1.5;
      margin-bottom: 20px;
    }
    > .line {
      height: 1px;
      opacity: 50%;
      background-color: var(--color-black-2);
      margin-bottom: 20px;
    }
    table {
      text-align: left;
      min-width: 200px;
      font-size: 1.2em;
      > tbody {
        > tr {
          height: 50px;
          > td {
            padding-left: 10px;
            height: 50px;
          }
        }
      }
    }
    .colors {
      display: flex;
      align-items: center;
      position: relative;
      span {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 15px;
        height: 15px;
        border-radius: 100px;
        margin-right: 10px;
      }
    }
    > .add-to-cart {
      margin-top: 20px;
      width: 100%;
      max-width: 300px;
    }
    > .added {
      background-color: var(--color-primary-5);
      cursor: auto;
    }
  }
  @media screen and (max-width: 550px) {
    grid-template-columns: 1fr;
    > .image {
      img {
        height: auto;
        max-height: 50vh;
      }
    }
  }
`;

export default Product;
